import { post, API_ROOT } from './api';

export const auth = ({ login, password }) =>
  post(
    `${API_ROOT}/users/sign_in/`,
    JSON.stringify({ user: { email: login, password } }),
    {
      'Content-Type': 'application/json',
    }
  );



// WEBPACK FOOTER //
// ./src/services/authApi.js